import React, {useState} from 'react';
import JESourceToSCOTs from './JESourceToSCOTs';
import styled from 'styled-components';
import MotifTabNavigation from '@ey/motif-react-wrapper/TabNavigation';
import MotifTabControl from '@ey/motif-react-wrapper/TabControl';
import {labels} from '../../../../util/utils';

const IdSCOTsSummary = () => {
	const [showJESourceTable, setShowJESourceTable] = useState(true);
	return (
		<StyledIdSCOTsSummary>
			<MotifTabNavigation defaultActiveKey={0}>
				<StyledMotifTabControl hoverFixLabel={labels.jeSourcesToSCOTs} onClick={() => setShowJESourceTable(true)}>
					{labels.jeSourcesToSCOTs}
				</StyledMotifTabControl>
				<StyledMotifTabControl
					hoverFixLabel={labels.scotsToSignificantAccounts}
					onClick={() => setShowJESourceTable(false)}
				>
					{labels.scotsToSignificantAccounts}
				</StyledMotifTabControl>
			</MotifTabNavigation>
			{showJESourceTable ? <JESourceToSCOTs /> : 'Under development :)'}
		</StyledIdSCOTsSummary>
	);
};

export default IdSCOTsSummary;

const StyledIdSCOTsSummary = styled.section`
	height: 90vh;
`;

const StyledMotifTabControl = styled(MotifTabControl)`
	display: inline-flex;
	flex-direction: column;
	text-align: center;
	&::before {
		content: "${(props) => props.hoverFixLabel}";
		overflow: hidden;
		visibility: hidden;
		height: 0 !important;
		font-weight: 600 !important;
	}
`;
